import { watch } from 'vue'

import {
  getMessageDraft,
  setMessageDraft,
} from '@/modules/chat-matrix-fast/utils/messageDrafts'

interface IUseMessageDraftSyncParams {
  msg: { value: string }
  getChatId: () => string | number | null | undefined
  /** Не сохраняем текст режима редактирования как черновик. */
  isEditing?: () => boolean
  onLeaveChat?: () => void
}

/** Сохраняет текст инпута при смене чата и восстанавливает при открытии. */
export function useMessageDraftSync(params: IUseMessageDraftSyncParams): void {
  watch(
    () => params.getChatId(),
    (nextId, prevId) => {
      if (prevId != null && String(prevId) !== String(nextId ?? '')) {
        if (!params.isEditing?.()) {
          setMessageDraft(prevId, params.msg.value)
        }
        params.onLeaveChat?.()
      }

      if (nextId == null) {
        params.msg.value = ''
        return
      }

      if (params.isEditing?.()) {
        return
      }

      params.msg.value = getMessageDraft(nextId)
    },
    { immediate: true },
  )
}
